import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AddOrganizationModule } from '@features/add-organization/add-organization.module';
import { ApplicationDownloadModule } from '@features/application-download/application-download.module';
import { ApplicationPdfModule } from '@features/application-pdf/application-pdf.module';
import { CancelRequestRevisionModalComponent } from '@features/application-view/cancel-request-revision-modal/cancel-request-revision-modal.component';
import { RequestRevisionModalComponent } from '@features/application-view/request-revision-modal/request-revision-modal.component';
import { ApproveAwardPayModule } from '@features/approve-award-pay/approve-award-pay.module';
import { ArchiveModule } from '@features/archive/archive.module';
import { AwardsModule } from '@features/awards/awards.module';
import { BudgetAssignmentsModule } from '@features/budget-assignments/budget-assignments.module';
import { CommunicationsModule } from '@features/communications/communications.module';
import { CopyApplicationModule } from '@features/copy-application/copy-application.module';
import { DocumentTemplateModule } from '@features/document-templates/document-templates.module';
import { FormRendererModule } from '@features/forms/form-renderer-module';
import { OfflineGrantsCreateEditApplicationModule } from '@features/offline-grants/offline-grants-create-edit-application/offline-grants-create-edit-application.module';
import { PaymentDisplayHelpersModule } from '@features/payment-display-helpers/payment-display-helpers.module';
import { SelectEmailTemplateModule } from '@features/system-emails/select-email-template/select-email-template.module';
import { SystemTagsModule } from '@features/system-tags/system-tags.module';
import { CancelApplicationModule } from '../cancel-application/cancel-application.module';
import { NominationsModule } from '../nominations/nominations.module';
import { AddApplicantModalComponent } from './add-applicant-modal/add-applicant-modal.component';
import { ApplicantsPageComponent } from './applicants-page/applicants-page.component';
import { DeleteApplicationModalComponent } from './application-delete/delete-application-modal/delete-application-modal.component';
import { ApplicationManagerDrilldownComponent } from './application-manager-drilldown/application-manager-drilldown.component';
import { ApplicationManagerPageComponent } from './application-manager-page/application-manager-page.component';
import { ApplicationManagerTableComponent } from './application-manager-table/application-manager-table.component';
import { ApplicationManagerWrapperComponent } from './application-manager-wrapper/application-manager-wrapper.component';
import { ApproveDeclineModalComponent } from './approve-decline-modal/approve-decline-modal.component';
import { EditVendorIdModalComponent } from './edit-vendor-id-modal/edit-vendor-id-modal.component';
import { ExtendFormDueDateModalComponent } from './extend-form-due-date-modal/extend-form-due-date-modal.component';
import { FormManagerTableComponent } from './form-manager/form-manager-table/form-manager-table.component';
import { SendFormDueEmailModalComponent } from './form-manager/send-form-due-email-modal/send-form-due-email-modal.component';
import { FormReminderModalComponent } from './form-reminder-modal/form-reminder-modal.component';
import { MailMergeModalComponent } from './mail-merge-modal/mail-merge-modal.component';
import { NomineesPageComponent } from './nominees-page/nominees-page.component';
import { NotifyStatusModalComponent } from './notify-status-modal/notify-status-modal.component';
import { OrganizationsPageComponent } from './organizations-page/organizations-page.component';
import { AppManagerOptionsVisiblePipe } from './pipes/app-manager-options-visible.pipe';
import { RouteApplicationModalComponent } from './route-application-modal/route-application-modal.component';
import { UpdateAppCycleModalComponent } from './update-app-cycle-modal/update-app-cycle-modal.component';
import { UpdateProgramModalComponent } from './update-program-modal/update-program-modal.component';
import { UpdateStatusModalComponent } from './update-status-modal/update-status-modal.component';
import { ViewFormModalComponent } from './view-form-modal/view-form-modal.component';
import { ViewPaymentsModalComponent } from './view-payments-modal/view-payments-modal.component';

@NgModule({
  imports: [
    SystemTagsModule,
    GCCoreModule,
    NominationsModule,
    SelectEmailTemplateModule,
    AddOrganizationModule,
    AwardsModule,
    ApproveAwardPayModule,
    ArchiveModule,
    FormRendererModule,
    DocumentTemplateModule,
    BudgetAssignmentsModule,
    OfflineGrantsCreateEditApplicationModule,
    CancelApplicationModule,
    ApplicationDownloadModule,
    PaymentDisplayHelpersModule,
    ApplicationPdfModule,
    CommunicationsModule,
    CopyApplicationModule
  ],
  declarations: [
    DeleteApplicationModalComponent,
    ApplicationManagerTableComponent,
    UpdateStatusModalComponent,
    CancelRequestRevisionModalComponent,
    ApplicationManagerWrapperComponent,
    ApplicantsPageComponent,
    OrganizationsPageComponent,
    ViewPaymentsModalComponent,
    ApproveDeclineModalComponent,
    NotifyStatusModalComponent,
    RouteApplicationModalComponent,
    UpdateAppCycleModalComponent,
    ViewFormModalComponent,
    NomineesPageComponent,
    AddApplicantModalComponent,
    ApplicationManagerDrilldownComponent,
    EditVendorIdModalComponent,
    ApplicationManagerPageComponent,
    AppManagerOptionsVisiblePipe,
    ExtendFormDueDateModalComponent,
    FormManagerTableComponent,
    SendFormDueEmailModalComponent,
    MailMergeModalComponent,
    UpdateProgramModalComponent,
    RequestRevisionModalComponent,
    FormReminderModalComponent
  ],
  exports: [
    DeleteApplicationModalComponent,
    ApproveDeclineModalComponent,
    RouteApplicationModalComponent,
    ViewPaymentsModalComponent,
    ApplicationManagerTableComponent,
    AppManagerOptionsVisiblePipe,
    FormReminderModalComponent
  ]
})
export class ApplicationManagerModule { }
